import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { RootState, AppDispatch } from '../store/store';
import { getSessionStatusThunk } from '../store/signin/thunk';

export const useSessionStatus = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { sessionStatus, isLoading, error } = useSelector((state: RootState) => state.signInSlice);

  const fetchSessionStatus = useCallback(() => {
    dispatch(getSessionStatusThunk());
  }, [dispatch]);

  return {
    sessionStatus,
    isLoading,
    error,
    fetchSessionStatus
  };
}; 